// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sNpt","colBig":"styles_colBig__3ZWCJ","colSmall":"styles_colSmall__K91nb"};